module.exports = __webpack_public_path__ + "static/img/4.96a910e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/4.png
// module id = wojX
// module chunks = 0